import * as types from './types';
import { LEASE_TYPE, FIXED_ADDENDUM, CONDITIONAL_ADDENDUM } from 'helpers/DocumentTemplateHelper';
import isEmpty from 'lodash/isEmpty';

export function storeDocumentTemplatesByTypes(documentTemplates) {
  const availableDocumentTemplates = documentTemplates.filter(
    (docTemp) => docTemp.signable_doc_type === LEASE_TYPE
  );
  const conditionalAddendums = documentTemplates.filter(
    (docTemp) => docTemp.signable_doc_type === CONDITIONAL_ADDENDUM
  );
  const fixedAddendums = documentTemplates.filter(
    (docTemp) => docTemp.signable_doc_type === FIXED_ADDENDUM
  );

  return {
    type: types.STORE_DOCUMENT_TEMPLATES_FOR_PROPERTY,
    documentTemplateForProperty: documentTemplates,
    availableDocumentTemplates: availableDocumentTemplates,
    conditionalAddendums: conditionalAddendums,
    fixedAddendums: fixedAddendums,
  };
}

export function storeBaseDocumentTemplate(selectedDocumentTemplate) {
  return {
    type: types.STORE_BASE_DOCUMENT_TEMPLATE,
    selectedBaseDocumentTemplate: selectedDocumentTemplate,
  };
}

export function storeFixedAddendumsForLease(selectedDocumentTemplate, fixedAddendums) {
  const fixedAddendumsForLease = fixedAddendums.filter((fixedAddendum) =>
    fixedAddendum.base_document_template_ids.includes(selectedDocumentTemplate?.value)
  );
  return {
    type: types.STORE_FIXED_ADDENDUMS_FOR_LEASE,
    fixedAddendumsForLease: fixedAddendumsForLease,
  };
}

export function storeConditionalAddendumsForLease(rentableItems, conditionalAddendums) {
  let conditionalAddendumsForLease = [];

  if (!isEmpty(rentableItems)) {
    const rentableItemTypes = rentableItems.map((rentableItem) => rentableItem.asset_type);
    conditionalAddendumsForLease = conditionalAddendums.filter((conditionalAddendum) =>
      rentableItemTypes.includes(conditionalAddendum.conditional_addendum_name)
    );
  }

  return {
    type: types.STORE_CONDITIONAL_ADDENDUMS_FOR_LEASE,
    conditionalAddendumsForLease: conditionalAddendumsForLease,
  };
}

export function storeAvailableAdditionalCharges(
  selectedDocumentTemplate,
  fixedAddendumsForLease,
  conditionalAddendumsForLease
) {
  let availableAdditionalCharges = [...selectedDocumentTemplate.additional_charges];

  fixedAddendumsForLease.forEach((fixedAddendum) =>
    availableAdditionalCharges.push(...fixedAddendum.additional_charges)
  );

  conditionalAddendumsForLease.forEach((conditionalAddendum) =>
    availableAdditionalCharges.push(...conditionalAddendum.additional_charges)
  );

  return {
    type: types.STORE_AVAILABLE_ADDITIONAL_CHARGES,
    availableAdditionalCharges: availableAdditionalCharges,
  };
}

export function storeCurrentAdditionalChargesForLease(
  currentAdditionalChargesForLeaseToStore,
  availableAdditionalCharges
) {
  let currentAdditionalChargesForLease = [];

  if (!isEmpty(availableAdditionalCharges)) {
    const availabeAdditionalChargeIds = availableAdditionalCharges.map(
      (additionalCharge) => additionalCharge.id
    );

    currentAdditionalChargesForLease = currentAdditionalChargesForLeaseToStore.filter(
      (currentAdditionalCharge) => availabeAdditionalChargeIds.includes(currentAdditionalCharge.id)
    );
  }

  return {
    type: types.STORE_CURRENT_ADDITIONAL_CHARGES_FOR_LEASE,
    currentAdditionalChargesForLease: currentAdditionalChargesForLease,
  };
}

export function storeCurrentRentableItemsForLease(currentRentableItemsForLease) {
  let rentableItems = [];
  if (!isEmpty(currentRentableItemsForLease)) {
    rentableItems = currentRentableItemsForLease;
  }
  return {
    type: types.STORE_CURRENT_RENTABLE_ITEMS_FOR_LEASE,
    currentRentableItemsForLease: rentableItems,
  };
}

export function storeServicesAndUtilitiesForLease(
  originalDocumentTemplate,
  selectedDocumentTemplate,
  leaseFormValues
) {
  let services = [];
  let utilities = [];

  if (originalDocumentTemplate?.value === selectedDocumentTemplate.value) {
    services = leaseFormValues.services;
    utilities = leaseFormValues.utilities;
  } else if (!isEmpty(selectedDocumentTemplate.services_and_utilities)) {
    services = selectedDocumentTemplate.services_and_utilities.filter(
      (item) => item.service_or_utility === 'service'
    );
    utilities = selectedDocumentTemplate.services_and_utilities.filter(
      (item) => item.service_or_utility === 'utility'
    );
  }

  return {
    type: types.STORE_SERVICES_AND_UTILITIES_FOR_LEASE,
    servicesForLease: services,
    utilitiesForLease: utilities,
  };
}

export function storeAdditionalFieldsForLease(
  selectedDocumentTemplate,
  fixedAddendumsForLease,
  conditionalAddendumsForLease
) {
  let availableAdditionalFields = [...selectedDocumentTemplate.additional_fields];

  fixedAddendumsForLease.forEach((fixedAddendum) =>
    availableAdditionalFields.push(...fixedAddendum.additional_fields)
  );

  conditionalAddendumsForLease.forEach((conditionalAddendum) =>
    availableAdditionalFields.push(...conditionalAddendum.additional_fields)
  );

  return {
    type: types.STORE_ADDITIONAL_FIELDS_FOR_LEASE,
    additionalFieldsForLease: availableAdditionalFields,
  };
}

export function storeLeaseReviews(leaseReviews) {
  return {
    type: types.STORE_LEASE_REVIEWS,
    leaseReviews: leaseReviews,
  };
}

export function storeLatestLeaseReview(latestLeaseReview) {
  return {
    type: types.STORE_LATEST_LEASE_REVIEW,
    latestLeaseReview: latestLeaseReview,
  };
}
